import axios from 'axios';

import firebase from '@/firebase';

const requestInterceptor = async (request) => {
  const token = await firebase.auth().currentUser.getIdToken();
  const headers = {
    Authorization: `Bearer ${token}`,
    ...request.headers,
  };

  return { ...request, headers };
};

const client = axios.create({ baseURL: process.env.VUE_APP_API_URL });
client.interceptors.request.use(requestInterceptor);
export default client;
